import React, { Component } from 'react';
import { connect } from "react-redux";
import { RemoveUploadFile } from '$Deposits/store/actions/DepositAction'
import Button from './Button';
import UploadFileModal from './UploadFileModal';
import { GetParamsData } from '$Deposits/lib/LibCommonData'

class UploadFile extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            uploadVisible: false,
            file: '',
            upload: false,
        };
    }

    componentDidMount() {

    }

    componentDidUpdate(prevProps) {
        // 当父组件传入新的图片后，开始渲染

    }
    componentWillUnmount() {
        this.props.RemoveUploadFile()
    }


    render() {
        const { uploadVisible } = this.state;
        const { UploadFileList, RemoveUploadFile } = this.props
        const { fileName } = UploadFileList || {}
        const { webPiwikEvent } = GetParamsData()

        return (
            <div className='uploadFile'>
                <div className='upload'>
                    <span className='inputTitle' data-CN='存款明細'>สลิปการโอน</span>
                    <span className="recommended-label">แนะนำ</span>
                </div>
                <div className='fileList'>
                    {
                        fileName && (
                            <div className='uploadedBox'>
                                {fileName}
                                <span className='removeIcon'onClick={()=>{RemoveUploadFile()}} />
                            </div>
                        )}
                    {
                        !fileName &&
                        <Button 
                            className="uploadBtn"
                            data-CN="上傳交易證明"
                            onClick={() => {
                                webPiwikEvent("Deposit", "Upload Slip", "Deposit_Old_Bank_C_Upload")
                                this.setState({uploadVisible: true})
                            }}
                        >
                            <span className='addIcon'/>
                            อัปโหลดหลักฐานการฝากเงิน
                        </Button>
                    }
                </div>

                {/* 上傳檔案跳窗 */}
                <UploadFileModal 
                    visible={uploadVisible} 
                    setVisible={(status)=>{this.setState({uploadVisible:status})}}
                />
            </div>
        );
    }
}

const mapStateToProps = state => ({
    UploadFileList: state.UploadFileList,
});
const mapDispatchToProps = {
    RemoveUploadFile: () => RemoveUploadFile(),

};
export default connect(mapStateToProps, mapDispatchToProps)(UploadFile);
